<template>
    <div>      
        <div class="power-card-header" :class="[basic.type]">
            <h2 class="power-card-title">
                {{ basic.name }}
            </h2>
            <h3 class="has-text-weight-bold">
                {{ classAndLevel }}
            </h3>
        </div>
        <div class="power-card-body">
            <div v-if="typeAndKeywords" class="has-text-weight-bold">
                {{ typeAndKeywords }}
            </div>
            <div v-if="actionAndRange" class="has-text-weight-bold">
                {{ actionAndRange }}
            </div>
            <div v-if="monk.attackTechniqueName">
                <strong>Attack Technique:</strong> {{ monk.attackTechniqueName }}
            </div>
            <div v-if="basic.requirement">
                <strong>Requirement:</strong> {{ basic.requirement }}
            </div>
            <div v-if="basic.trigger">
                <strong>Trigger:</strong> {{ basic.trigger }}
            </div>
            <div v-if="basic.beforeSpecial">
                <strong>Special:</strong> {{ basic.beforeSpecial }}
            </div>
            <div v-if="basic.beforeEffect">
                <strong>Effect:</strong> {{ basic.beforeEffect }}
            </div>
            <div v-if="basic.target && attack.type != 'multiple'">
                <strong>Target:</strong> {{ basic.target }}
            </div>                
            <div v-else-if="basic.target && attack.type == 'multiple'">
                <strong>Primary Target:</strong> {{ basic.target }}
            </div>
            <div v-if="primaryAttackLine && attack.type != 'multiple'">
                <strong>Attack:</strong> {{ primaryAttackLine }} vs <strong>{{ attack.primary.defense }}</strong>
            </div>         
            <div v-else-if="primaryAttackLine && attack.type == 'multiple'">
                <strong>Primary Attack:</strong> {{ primaryAttackLine }} vs <strong>{{ attack.primary.defense }}</strong>
            </div>
            <div v-if="primaryDamageLine">
                <strong>Hit:</strong> {{ primaryDamageLine }}
            </div>
            <div v-if="attack.primary.hitEffect">
                <strong>On Hit:</strong> {{ attack.primary.hitEffect }}
            </div>
            <div v-if="attack.type == 'multiple' && attack.secondary.target != ''">
                <strong>Secondary Target:</strong> {{ attack.secondary.target }}
            </div>
            <div v-if="attack.type == 'multiple' && secondaryAttackLine">
                <strong>Secondary Attack:</strong> {{ secondaryAttackLine }} vs <strong>{{ attack.secondary.defense }}</strong>
            </div> 
            <div v-if="secondaryDamageLine">
                <strong>Hit:</strong> {{ secondaryDamageLine }}
            </div>
            <div v-if="attack.secondary.hitEffect">
                <strong>On Hit:</strong> {{ attack.secondary.hitEffect }}
            </div> 
            <div v-if="attack.type == 'multiple' && attack.tertiary.target != ''">
                <strong>Tertiary Target:</strong> {{ attack.tertiary.target }}
            </div>
            <div v-if="tertiaryAttackLine">
                <strong>Tertiary Attack:</strong> {{ tertiaryAttackLine }} vs <strong>{{ attack.tertiary.defense }}</strong>
            </div> 
            <div v-if="tertiaryDamageLine">
                <strong>Hit:</strong> {{ tertiaryDamageLine }}
            </div>
            <div v-if="attack.tertiary.hitEffect">
                <strong>On Hit:</strong> {{ attack.tertiary.hitEffect }}
            </div> 
            <div v-if="attack.missEffect">
                <strong>Miss:</strong> {{ attack.missEffect }}
            </div>
            <div v-if="basic.effect">
                <strong>Effect:</strong> {{ basic.effect }}
            </div>            
            <div v-if="attack.failedSaves.first">
                <strong>First Failed Save:</strong> {{ attack.failedSaves.first }}
            </div>                    
            <div v-if="attack.failedSaves.second">
                <strong>Second Failed Save:</strong> {{ attack.failedSaves.second }}
            </div>                    
            <div v-if="attack.failedSaves.third">
                <strong>Third Failed Save:</strong> {{ attack.failedSaves.third }}
            </div>            
            <div v-if="monk.moveTechnique.name">
                <strong>Move Technique:</strong> {{ monk.moveTechnique.name }}
            </div>
            <div v-if="moveTechniqueActionAndRange">
                <strong>{{ moveTechniqueActionAndRange }}</strong>                
            </div>
            <div v-if="monk.moveTechnique.target">
                <strong>Target:</strong> {{ monk.moveTechnique.target }}
            </div>
            <div v-if="monk.moveTechnique.effect">
                <strong>Effect:</strong> {{ monk.moveTechnique.effect }}
            </div>
            <div v-if="basic.special">
                <strong>Special:</strong> {{ basic.special }}
            </div>         
            <div v-for="(singleCustom, index) in displayCustom" :key="`customTag-${index}`">
                <div v-if="singleCustom.label && singleCustom.value"><strong>{{ singleCustom.label }}:</strong> {{ singleCustom.value }}</div>
            </div>
        </div>        
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {  
    props: {

    },
    data: function() {
        return {
            separator: " ♦ ",
        };
    },
    computed: {
        ...mapState({
            basic: state => state.basic,
            attack: state => state.attack,
            damage: state => state.damage,
            custom: state => state.custom,
            monk: state => state.monk,
            psion: state => state.psion,
        }),                
        classAndLevel: function() {
            return this.basic.level ? `${this.basic.powerClass} ${this.basic.level}` : this.basic.powerClass;
        },
        typeAndKeywords: function() {
            return [ this.basic.typeName, this.basic.keywords ].filter((item) => item != '').join(this.separator);
        },
        actionAndRange: function() {
            return [ this.basic.actionType, this.basic.range ].filter((item) => item != '').join(this.separator);
        },
        moveTechniqueActionAndRange: function() {
            return [ this.monk.moveTechnique.type, this.monk.moveTechnique.range ].filter((item) => item != '').join(this.separator);
        },
        displayCustom: function() {
            return this.custom.custom.filter((item) => item.label && item.value);
        },    
        primaryAttackLine: function() {
            return this.attack.isAttack ? this.getAttackParts('primary') : false;            
        },            
        primaryDamageLine: function() {
            return this.damage.primary.hasDamage ? this.getDamageParts('primary') : false;            
        },  
        secondaryAttackLine: function() {
            return this.attack.isAttack ? this.getAttackParts('secondary') : false;
        },
        secondaryDamageLine: function() {
            return this.damage.secondary.hasDamage ? this.getDamageParts('secondary') : false;            
        },
        tertiaryAttackLine: function() {
            return this.attack.isAttack && this.attack.tertiary.hasTertiary ? this.getAttackParts('tertiary') : false;
        },
        tertiaryDamageLine: function() {
            return this.attack.tertiary.hasTertiary && this.damage.tertiary.hasDamage ? this.getDamageParts('tertiary') : false;            
        },
    },
    methods: {
        getAttackParts(type) {
            let attackProps = this.attack[type];

            let attackBonusParts = [ '1d20' ];

            if(attackProps.bonusSource != 'static') {
                attackBonusParts.push(`${attackProps.stat} modifier`);
            }

            if(attackProps.weaponNumber != '' && (attackProps.bonusSource == 'weapon' || attackProps.bonusSource == 'implement')) {
                attackBonusParts.push(`(${attackProps.bonusSource}-${attackProps.weaponNumber} attack bonus)`);
            }

            if(attackProps.staticBonus != '') {
                attackBonusParts.push(attackProps.staticBonus);
            }

            return attackBonusParts.join(' + ');
        },
        getDamageParts(type) {
            let attackProps = this.attack[type];
            let damageProps = this.damage[type];

            let damageParts = [];

            if(attackProps.bonusSource == 'weapon') {
                if(damageProps.diceSides != '') {
                    damageParts.push(`${damageProps.diceQuantity}[W]`);
                }
            } else if(damageProps.diceSides != '' && damageProps.diceQuantity != '') {
                damageParts.push(`${damageProps.diceQuantity}d${damageProps.diceSides}`);
            }

            if(damageProps.addStatMod) {
                damageParts.push(`${attackProps.stat} modifier`);
            }

            if(attackProps.weaponNumber != '' && (attackProps.bonusSource == 'weapon' || attackProps.bonusSource == 'implement')) {
                damageParts.push(`(${attackProps.bonusSource}-${attackProps.weaponNumber} damage bonus)`);
            }

            if(damageProps.staticBonus != '') {
                damageParts.push(damageProps.staticBonus);
            }

            let finalDamage = damageParts.join(' + ');

            return damageProps.type != '' ? `${finalDamage} ${damageProps.type} damage.` : `${finalDamage} damage.`;            
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .power-card-header {
        padding: 0.5rem;
        color: white;
    }

    .power-card-header h2 {
        font-weight: bold;
        font-size: 1.2rem;
    }

    .power-card-header h3 {
        text-align: right;
    }

    .power-card-body {        
        border: 1px solid black;
        border-top: none;
    }

    .power-card-body > div {
        padding: 0.25rem 0.5rem;
    }

    .power-card-body > div:nth-of-type(odd) {
        background: linear-gradient(to right, rgba(217, 209, 199,1), rgba(217, 209, 199,0.25));
    }

    .power-card-header.atwill {
        background: #3a7042;
    }

    .power-card-header.encounter {
        background: #7d0824;
    }

    .power-card-header.daily {
        background: #333;
    }

    .power-card-header.item {
        background: #e6b800;
    }

    .power-card-header.other {
        background: #000;
    }

    .power-card-header.ability {
        background: #483d8b;
    }

    .power-card-header.skill {
        background: #3a5eca;
    }    
</style>
